import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import Icon from "@/components/Icons/Icon.vue";
import {computed} from "vue";
import buttonProps from "@/components/custom/ButtonFilterSelect/ButtonProps";
import {useSettingsStore} from "@/api/store/settings";


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonBase',
  props: {...buttonProps},
  emits: ['click'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const settingsStore = useSettingsStore();

const props = __props

const setColor = computed(() => {
  if (props.buttonColor === 'buttonColor') {
    return settingsStore.settings.buttonColor;
  }
  return props.buttonColor !== undefined ? props.buttonColor : settingsStore.settings.buttonColor2;
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createBlock(_component_v_btn, {
    class: _normalizeClass([_ctx.customClass, "b-round-20 text-capitalize position-relative"]),
    color: setColor.value,
    disabled: _ctx.disabled,
    variant: _ctx.variant,
    width: _ctx.width,
    flat: "",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "button-icon", {}, () => [
        (_ctx.icon)
          ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              class: _normalizeClass(_ctx.customIconClass),
              color: _ctx.colorIcon,
              icon: _ctx.icon
            }, null, 8, ["class", "color", "icon"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.text), 1),
      (_ctx.count && !_ctx.singleLine)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([{'primary-button': !_ctx.activeFilter, 'white-btn': _ctx.activeFilter}, "count"])
          }, _toDisplayString(_ctx.count), 3))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["class", "color", "disabled", "variant", "width"]))
}
}

})